import { Pagination, Stack } from "@mui/material";
import { PaginationInfo } from "./pagination-info";

interface CustomPaginationProps {
  page: number;
  totalItems: number;
  itemsPerPage: number;
  count: number;
  onPageChange: (page: number) => void;
}

const CustomPagination = ({
  page,
  totalItems,
  itemsPerPage,
  count,
  onPageChange,
}: CustomPaginationProps) => {
  return (
    <Stack
      sx={{
        justifyContent: "flex-end",
        alignItems: "center",
        mt: 4,
        px: 2,
        alignSelf: "center",
        flexDirection: "row", 
        ml: 'auto'
      }}
    >
      <PaginationInfo
        currentPage={page}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
      />
      <Pagination
        count={count}
        page={page}
        onChange={(e, v) => onPageChange(v)}
        color="primary"
        shape="rounded"
        size="small"
        siblingCount={0}
        boundaryCount={1}
      />
    </Stack>
  );
};

export { CustomPagination };
